/* Cabal · conversión
   1) barra de envío gratis en el carrito (si el umbral es 0, no se muestra)
   2) "Pedir por WhatsApp" con el carrito completo en el mensaje
   3) barra fija de pedido en móvil dentro de la ficha de producto
   4) el lenguaje del carrito habla de "pedido", no de "pagar" */
(function () {
  var C = window.CABAL || {};
  var WA = C.wa || '';
  var THRESH = Number(C.freeShip) || 0;
  var NL = String.fromCharCode(10);
  var WS = new RegExp('[' + String.fromCharCode(32, 9, 10, 13) + ']+', 'g');
  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M21 11.6a8.4 8.4 0 0 1-12.4 7.4L3.5 20.5l1.6-5.1A8.4 8.4 0 1 1 21 11.6Z"/>' +
    '<path d="M9 9.3c.3 1.7 1.4 3.1 2.9 4 .9.6 2 .9 3.1.9"/></svg>';

  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function waLink(text) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text); }

  /* ---------- 1 y 2: carrito ---------- */
  function shipNode(total) {
    var goal = THRESH * 100;
    var falta = goal - total;
    var pct = goal ? Math.min(100, Math.round((total / goal) * 100)) : 100;
    var n = document.createElement('div');
    n.className = 'cs-fs' + (falta > 0 ? '' : ' cs-fs--done');
    n.setAttribute('data-cs-fs', '');
    n.innerHTML =
      '<p class="cs-fs__t">' +
      (falta > 0
        ? 'Te faltan <b>' + money(falta) + '</b> para el envío gratis'
        : 'Tu pedido ya tiene <b>envío gratis</b>') +
      '</p><span class="cs-fs__bar"><i style="width:' + pct + '%"></i></span>';
    return n;
  }

  function waCartNode(cart) {
    var lines = cart.items.map(function (i) {
      return '- ' + i.quantity + ' x ' + i.product_title + ' (' + money(i.line_price) + ')';
    });
    var msg =
      'Hola Cabal, quiero hacer este pedido:' + NL + NL +
      lines.join(NL) + NL + NL +
      'Total: ' + money(cart.total_price);
    var a = document.createElement('a');
    a.className = 'cs-wa-cta cs-wa-cta--cart';
    a.setAttribute('data-cs-wa-cart', '');
    a.href = waLink(msg);
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = ICON + '<span>Completar pedido por WhatsApp</span>';
    return a;
  }

  function noteNode() {
    var p = document.createElement('p');
    p.className = 'cs-wa-note';
    p.setAttribute('data-cs-wa-note', '');
    p.textContent = 'Te respondemos y coordinamos pago y entrega por ahí mismo.';
    return p;
  }

  function targets() {
    var list = document.querySelectorAll('.cart__ctas');
    if (list.length) return Array.prototype.slice.call(list);
    var btn = document.querySelector('[name="checkout"]');
    return btn && btn.parentNode ? [btn.parentNode] : [];
  }

  var lastSig = '';
  var injecting = false;

  function render(cart) {
    var sig = cart ? cart.item_count + ':' + cart.total_price : '0';
    var present = !!document.querySelector('[data-cs-wa-cart]');
    if (sig === lastSig && present) return;
    injecting = true;
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-cs-fs],[data-cs-wa-cart],[data-cs-wa-note]'),
      function (n) { if (n.parentNode) n.parentNode.removeChild(n); }
    );
    if (cart && cart.item_count > 0 && WA) {
      targets().forEach(function (t) {
        var host = t.parentNode;
        if (!host) return;
        if (THRESH > 0) host.insertBefore(shipNode(cart.total_price), t);
        var cta = waCartNode(cart);
        host.insertBefore(cta, t.nextSibling);
        host.insertBefore(noteNode(), cta.nextSibling);
      });
    }
    lastSig = sig;
    setTimeout(function () { injecting = false; }, 60);
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch((C.cartUrl || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { busy = false; render(c); })
      .catch(function () { busy = false; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (injecting) return;
        lastSig = '';
        setTimeout(refresh, 40);
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { lastSig = ''; setTimeout(refresh, 100); });
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cs-open-cart]')) setTimeout(refresh, 300);
  });

  /* ---------- 3 y 4: ficha de producto ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var main = document.querySelector('main[data-template]');
    if (!main || String(main.dataset.template).indexOf('product') !== 0) return;
    var submit = document.querySelector('.product-form__submit');
    if (!submit) return;

    /* El botón de Dawn habla de carrito; aquí se arma un pedido. */
    function relabel() {
      var span = submit.querySelector('span') || submit;
      var t = (span.textContent || '').toLowerCase();
      if (t.indexOf('agregar') !== -1 || t.indexOf('añadir') !== -1 || t.indexOf('add to') !== -1) {
        span.textContent = 'Agregar al pedido';
      }
    }
    relabel();

    var waCta = document.querySelector('[data-cs-wa-product]');
    var bar = document.createElement('div');
    bar.className = 'cs-buybar';
    bar.innerHTML =
      '<span class="cs-buybar__p"></span>' +
      (waCta ? '<a class="cs-buybar__wa" href="' + waCta.getAttribute('href') + '" target="_blank" rel="noopener">' + ICON + '<span>Pedir por WhatsApp</span></a>' : '') +
      '<button type="button" class="cs-buybar__b">Agregar</button>';
    document.body.appendChild(bar);

    var priceEl = document.querySelector('.price__container');
    var pEl = bar.querySelector('.cs-buybar__p');
    var bEl = bar.querySelector('.cs-buybar__b');

    function sync() {
      if (priceEl) {
        var tokens = (priceEl.textContent || '').replace(WS, ' ').trim().split(' ');
        var price = '';
        for (var i = 0; i < tokens.length; i++) {
          if (tokens[i].charAt(0) === '$') { price = tokens[i]; break; }
        }
        pEl.textContent = price;
      }
      bEl.disabled = !!submit.disabled;
      bEl.textContent = submit.disabled ? 'Agotado' : 'Agregar';
      relabel();
    }

    bEl.addEventListener('click', function () { submit.click(); });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(submit);
    }
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(submit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    sync();
  });
})();